














import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted
} from '@vue/composition-api'

import AuthenticationFormCf from '@/components/authentication/AuthenticationFormCf.vue'

import {
  accessorFactory,
  Namespace
} from '@/store'
import {
  getIsAuthenticationOngoing,
  getAuthenticationError,
  getAuthenticationWarning,
  setAuthenticationError,
  setAuthenticationWarning,
  requestAuthentication,
  cancelAuthentication,
  getIsCancellationOngoing
} from '@/store/modules/authentication-v6.store'

import { Entry } from 'contentful'
import { CfAnslContactForm } from '@/types/ansl-space/types/cf-ansl-contact-form'

export default defineComponent({
  components: {
    AuthenticationFormCf
  },
  setup (_, context) {
    const store = context.root.$store

    const { getContent } = accessorFactory<Entry<CfAnslContactForm>>(Namespace.ContactFormContent)

    const bankIdDescription = computed(() => getContent(store)?.fields.bankIdDescription)
    const bankIdHelp = computed(() => getContent(store)?.fields.bankIdHelp)

    const isAuthenticationOngoing = computed(() => getIsAuthenticationOngoing(store))
    const isCancellationOngoing = computed(() => getIsCancellationOngoing(store))
    const authenticationError = computed(() => getAuthenticationError(store))
    const authenticationWarning = computed(() => getAuthenticationWarning(store))

    const cancel = () => cancelAuthentication(store)
    const startAuthentication = () => {
      requestAuthentication(store)
    }

    onMounted(() => {
      startAuthentication()
    }),

    onUnmounted(() => {
      setAuthenticationError(store, null)
      setAuthenticationWarning(store, null)

      if (isAuthenticationOngoing.value) {
        cancelAuthentication(store)
      }
    })

    return {
      bankIdDescription,
      bankIdHelp,

      isAuthenticationOngoing,
      isCancellationOngoing,
      authenticationError,
      authenticationWarning,

      startAuthentication,
      cancel
    }
  }
})
